export default "__VITE_ASSET__8oytVtmU__"